import { Injectable } from '@angular/core';
import { KeycloakAuthService } from './keycloak-auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermisionService {
  constructor(private authService: KeycloakAuthService) {}

  private groupPermissions: { [group: string]: string[] } = {
    'system admin': [
      'bots', 'learning-management', 'courses', 'topics', 'cohorts', 'quizzes',
      'content-management', 'property-management', 'student-management', 'reports',
      'user-management', 'integrations', 'security'
    ],
    'content editor': ['courses', 'topics', 'cohorts', 'quizzes', 'content-management'],
    'content contributor': ['courses', 'topics', 'cohorts', 'quizzes'],
    'external client user': ['reports', 'integrations']
  };

  getAccessibleSections(): string[] {
    const user = this.authService.currentUserValue();
    if (!user || !user.groups || !Array.isArray(user.groups)) {
      return [];
    }
    const accessibleSections = new Set<string>();
    user.groups.forEach(group => {
      const permissions = this.groupPermissions[group.toLowerCase()] || [];
      permissions.forEach(section => accessibleSections.add(section));
    });
    return Array.from(accessibleSections);
  }

  hasAccess(section: string): boolean {
    const accessibleSections = this.getAccessibleSections();
    return accessibleSections.includes(section);
  }
}